import script from "./OrderDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetailPage.vue?vue&type=style&index=0&id=6df048b1&lang=scss"

const __exports__ = script;

export default __exports__